<div class="modal">
    <div class="header">
        <h1 class="title" translate [translateParams]="{ group: ref.data.group.name }">PREMIUM_ADMIN_MEMBER_MODAL_DELETE_GROUP_QUESTION</h1>
    </div>
    <div class="body">
        <ng-container *ngIf="(deleteGroupPending$ | async); else notProcessing">
            <div class="loading-container">
                <div class="loading-spinner-grey"></div>
            </div>
        </ng-container>
        <ng-template #notProcessing>
            <div class="section">
                <div class="description" translate> PREMIUM_ADMIN_MEMBER_MODAL_DELETE_GROUP_QUESTION_CONFIRMATION</div>
            </div>
        </ng-template>
    </div>
    <div class="footer">
        <button class="btn-new white" type="submit" (click)="close()"
            [disabled]="(deleteGroupPending$ | async)">{{'PREMIUM_ADMIN_MEMBER_MODAL_ADD_GROUP_BUTTON_LABEL_CANCEL' | translate}}</button>
        <button class="btn-new red" (click)="deleteGroup()" [disabled]="(deleteGroupPending$ | async)"
            translate>PREMIUM_ADMIN_MEMBER_MODAL_DELETE_GROUP_BUTTON_LABEL_DELETE_GROUP</button>
    </div>
</div>